import React from 'react'
import { Button } from 'react-components/atoms'

const LandingIscrizione = (props) => {
  const { className = '', onClick } = props

  return (
    <div className={`landing-iscrizione ${className ? ` ${className}` : ''}`}>
      <div className="landing-iscrizione__button">
        <Button label="Iscriviti" onClick={onClick} />
      </div>
    </div>
  )
}

export default LandingIscrizione
